import { Controller } from "@hotwired/stimulus"

// Drives the sticky anchor-chip navigation on the billing settings tab.
// Chips smooth-scroll to their target section; the chip for the section
// currently in view is highlighted via an IntersectionObserver.
export default class extends Controller {
  static targets = ["chip"]
  static classes = ["active", "inactive"]

  connect() {
    this.sections = this.chipTargets
      .map((chip) => document.getElementById(chip.dataset.targetId))
      .filter(Boolean)

    this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
      rootMargin: "-20% 0px -70% 0px",
      threshold: 0,
    })
    this.sections.forEach((section) => this.observer.observe(section))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  scrollTo(event) {
    event.preventDefault()
    const target = document.getElementById(event.currentTarget.dataset.targetId)
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  onIntersect(entries) {
    const visible = entries.find((entry) => entry.isIntersecting)
    if (visible) this.highlight(visible.target.id)
  }

  highlight(sectionId) {
    this.chipTargets.forEach((chip) => {
      const isActive = chip.dataset.targetId === sectionId
      chip.classList.remove(...(isActive ? this.inactiveClasses : this.activeClasses))
      chip.classList.add(...(isActive ? this.activeClasses : this.inactiveClasses))
    })
  }
}
